<template>
  <div>
    <section>
      <TippCard
        hintID="Mitgliederverwaltung_Zielvorgaben_Ausnahmen_1_V1"
        text="Werden Ausnahmen für einzelne Mitglieder angelegt, werden diese bei der Berechnung der Zielvorgaben berücksichtigt."
      >
      </TippCard>
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <Subheader
                icon="mdi-progress-star"
                title="Ausnahmen"
                :actions="actions"
              ></Subheader>
              <div class="mt-7">
                <v-data-table
                  :items="exceptions"
                  :headers="headers"
                  :sort-by="sortBy.toLowerCase()"
                  :sort-desc="sortDesc"
                  item-key="meta.id"
                  class="elevation-2"
                  no-data-text="Keine Ausnahmen vorhanden"
                >
                  <!-- <template v-slot:group.header="{ items, isOpen, toggle }">
                    <th :colspan="headers.length">
                      <v-icon @click="toggle" class="mr-1"
                        >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                      </v-icon>
                      {{ stripPrefix(items[0].groupByTitle) }}
                    </th>
                  </template> -->
                  <template v-slot:item.isActive="{ item }">
                    <v-simple-checkbox
                      v-model="item.isActive"
                      color="primary"
                      disabled
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.validFrom.timestamp="{ item }">
                    {{ timestampConverter(item.validFrom.timestamp) }}
                  </template>
                  <template v-slot:item.validUntil.timestamp="{ item }">
                    {{ timestampConverter(item.validUntil.timestamp) }}
                  </template>
                  <template v-slot:[`item.progress`]="{ item }">
                    <date-progress-bar
                      :start="item.validFrom.timestamp"
                      :end="item.validUntil.timestamp"
                    ></date-progress-bar>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      class="mr-2"
                      :to="{
                        name: 'member-management-performance-targets-exceptions-edit',
                        params: {
                          organizationId: $route.params.organizationId,
                          itemId: item.meta.id,
                        },
                      }"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    ><v-btn icon text color="error" disabled
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import DateProgressBar from "@/components/_systemwide/DateProgressBar.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { GET_EXCEPTIONS } from "@/store/action-types.js";
import { MEMBER_MANAGEMENTS_PERFORMANCE_TARGETS_EXCEPTIONS_create } from "@/data/permission-types.js";

export default {
  name: "member-management-performance-targets-exceptions",
  components: {
    TippCard,
    Subheader,
    DateProgressBar,
    SupportTools,
  },
  data() {
    return {
      sortDesc: false,
      sortBy: "sortKey",

      actions: [
        {
          title: "Erstellen",
          icon: "mdi-playlist-plus",
          permission: `${MEMBER_MANAGEMENTS_PERFORMANCE_TARGETS_EXCEPTIONS_create}`,
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "member-management-performance-targets-exceptions-new",
              params: {
                organizationId: this.$route.params.organizationId,
              },
            });
          },
        },
      ],

      headers: [
        {
          text: "Vorname",
          value: "user.firstName",
          align: "start",
        },
        {
          text: "Nachname",
          value: "user.lastName",
          align: "start",
        },
        {
          text: "Grund",
          value: "reason",
        },
        {
          text: "Gültigkeitsbeginn",
          value: "validFrom.timestamp",
        },
        {
          text: "Gültigkeitsende",
          value: "validUntil.timestamp",
        },
        {
          text: "Fortschritt",
          value: "progress",
        },
        {
          text: "Aktiv",
          value: "isActive",
        },
        { text: "", value: "actions" },
      ],
      expanded: [],
      helpers: {},
    };
  },
  computed: {
    exceptions() {
      return this.$store.state.memberManagement.exceptions;
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [{ title: "exceptions", data: this.exceptions }];
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_EXCEPTIONS}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    timestampConverter(timestamp) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
